import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
} from '@mui/material';
import { Lx } from '../../../i18n/consts';
import useSnack from '../../../hooks/useSnack';
import styles from './delete-dialog.module.scss';
import { SVGS } from '../../../assets/images';
import { useMediaQuery } from 'react-responsive';
import { ActionCancelButtonsArea } from '../action-cancel-buttons-area';

interface DeleteDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirmDelete: () => void;
    deleteMessage: string;
    deleteHeader: string;
    title: string;
    idDeleteButtonLocalization?: string; 
}

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
    open,
    onCancel,
    onConfirmDelete,
    deleteMessage,
    deleteHeader,
    title,
    idDeleteButtonLocalization
}) => {
    const isMobile = useMediaQuery({ maxWidth: 1000  });
    const snack = useSnack();
    
    const onDelete = () => {
        try {
            onConfirmDelete();
            snack(`Deleted: ${title}`, 'success');
        }
        catch(error) {
            console.log(error);
            snack('An unexpected error occurred', 'error');
        }
    }
    return (
        <Dialog
            open={open}
            fullScreen={isMobile ? true : false}
            onClose={onCancel}
            aria-labelledby="confirm-delete-dialog-title"
            aria-describedby="confirm-delete-dialog-description"
            PaperProps={{
                className: styles.dialogPaper,
            }}>
            {isMobile 
                ? <></>
                : <IconButton
                    aria-label="close"
                    onClick={onCancel}
                    className={styles.dialogCloseButton}>
                    <SVGS.CrossIcon style={{width: '13.185px', height: '13.185px'}} />
                </IconButton>
            }
            <DialogContent
                className={styles.dialogContentRoot}>
                
                <DialogContent id="confirm-delete-dialog-description"
                    className={styles.dialogContentInner}>
                    <div className={styles.dialogDeleteHeader}>
                        <div className={styles.dialogDeleteIcon}>
                            <SVGS.DeleteIcon style={{width: '32px', height: '32px', fill: 'var(--default-svg-color)'}} />
                        </div>
                        {deleteHeader}</div>
                    {deleteMessage}
                </DialogContent>
            </DialogContent>
            <DialogActions
                className={styles.dialogActions}>
                <ActionCancelButtonsArea
                    idActionLocalization={idDeleteButtonLocalization ? idDeleteButtonLocalization : Lx.General.DELETE}
                    onCancel={onCancel}
                    onAction={onDelete}
                />
            </DialogActions>
        </Dialog>
    );
};
